var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutCard',{attrs:{"title":_vm.$t('hat.screen.Members')}},[_c('ScatterChartIndex',{attrs:{"chartData":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }